// extracted by mini-css-extract-plugin
module.exports = {"SegLeftBtn":"SegmentControl_SegLeftBtn__3RrdT","SegMiddleBtn":"SegmentControl_SegMiddleBtn__3Md71","SegRightBtn":"SegmentControl_SegRightBtn__1bEOH"};